// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currentReport_report__eazIe {
  width: 50%;
  padding: 0px 0px 30px 30px;
  overflow: auto; }
  .currentReport_report_scale__87Cg4 {
    position: absolute;
    bottom: 10px;
    right: 10px;
    z-index: 5; }
  .currentReport_report_image__N902P {
    position: relative;
    width: 100%;
    margin-bottom: 20px; }
    .currentReport_report_image_src__M4Bgo {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center center; }
    .currentReport_report_image_time__zCbwN {
      position: absolute;
      bottom: 20px;
      left: 0;
      width: 100%;
      z-index: 500;
      display: flex;
      justify-content: center; }
      .currentReport_report_image_time__zCbwN span {
        padding: 5px 50px;
        background: #00000050;
        color: white;
        border-radius: 21px; }
  .currentReport_report_item__8yf-m {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e0e0e0; }
    .currentReport_report_item__8yf-m .currentReport_legend__0hKsp {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      color: #9e9e9e; }
    .currentReport_report_item__8yf-m .currentReport_text__cpO93 {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 16px; }
    .currentReport_report_item__8yf-m .currentReport_link__2j91\\+ {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #fe6100;
      cursor: pointer;
      transition: all 0.4s; }
      .currentReport_report_item__8yf-m .currentReport_link__2j91\\+:hover {
        color: #E55700; }
    .currentReport_report_item_red__sfFrc {
      width: 50px;
      height: 20px;
      background-color: #e00606; }
    .currentReport_report_item_green__JwX5c {
      width: 50px;
      height: 20px;
      background-color: #87bc45; }

.currentReport_fullImage__eYciG {
  width: 100vw;
  height: 100vh;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background-color: #00000070;
  backdrop-filter: blur(5px);
  z-index: 9000;
  cursor: pointer; }
  .currentReport_fullImage__container__0hc15 {
    position: relative;
    width: 85vw;
    height: max-content;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center; }
  .currentReport_fullImage__scale__yryV3 {
    position: absolute;
    bottom: 10px;
    right: 10px; }
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/components/reports/currentReport.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,0BAA0B;EAC1B,cAAc,EAAA;EACd;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU,EAAA;EAEZ;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAA;IACnB;MACE,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;MACZ,mBAAmB;MACnB,8BAA8B,EAAA;IAEhC;MACE,kBAAkB;MAClB,YAAY;MACZ,OAAO;MACP,WAAW;MACX,YAAY;MACZ,aAAa;MACb,uBAAuB,EAAA;MAPxB;QASG,iBAAiB;QACjB,qBAAqB;QACrB,YAAY;QACZ,mBAAmB,EAAA;EAIzB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC,EAAA;IALjC;MAOG,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,cAAc,EAAA;IAXjB;MAcG,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe,EAAA;IAjBlB;MAoBG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,eAAe;MACf,oBAAoB,EAAA;MAzBvB;QA2BK,cAAa,EAAA;IAGjB;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB,EAAA;IAE3B;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB,EAAA;;AAK/B;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,eAAe,EAAA;EACf;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAEzB;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAA","sourcesContent":[".report {\n  width: 50%;\n  padding: 0px 0px 30px 30px;\n  overflow: auto;\n  &_scale {\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    z-index: 5;\n  }\n  &_image {\n    position: relative;\n    width: 100%;\n    margin-bottom: 20px;\n    &_src {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      object-position: center center;\n    }\n    &_time {\n      position: absolute;\n      bottom: 20px;\n      left: 0;\n      width: 100%;\n      z-index: 500;\n      display: flex;\n      justify-content: center;\n      span {\n        padding: 5px 50px;\n        background: #00000050;\n        color: white;\n        border-radius: 21px;\n      }\n    }\n  }\n  &_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #e0e0e0;\n    .legend {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 12px;\n      color: #9e9e9e;\n    }\n    .text {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n    }\n    .link {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      color: #fe6100;\n      cursor: pointer;\n      transition: all 0.4s;\n      &:hover{\n        color:#E55700;\n      }\n    }\n    &_red {\n      width: 50px;\n      height: 20px;\n      background-color: #e00606;\n    }\n    &_green {\n      width: 50px;\n      height: 20px;\n      background-color: #87bc45;\n    }\n  }\n}\n\n.fullImage {\n  width: 100vw;\n  height: 100vh;\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 0;\n  left: 0;\n  background-color: #00000070;\n  backdrop-filter: blur(5px);\n  z-index: 9000;\n  cursor: pointer;\n  &__container {\n    position: relative;\n    width: 85vw;\n    height: max-content;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &__scale {\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"report": `currentReport_report__eazIe`,
	"report_scale": `currentReport_report_scale__87Cg4`,
	"report_image": `currentReport_report_image__N902P`,
	"report_image_src": `currentReport_report_image_src__M4Bgo`,
	"report_image_time": `currentReport_report_image_time__zCbwN`,
	"report_item": `currentReport_report_item__8yf-m`,
	"legend": `currentReport_legend__0hKsp`,
	"text": `currentReport_text__cpO93`,
	"link": `currentReport_link__2j91+`,
	"report_item_red": `currentReport_report_item_red__sfFrc`,
	"report_item_green": `currentReport_report_item_green__JwX5c`,
	"fullImage": `currentReport_fullImage__eYciG`,
	"fullImage__container": `currentReport_fullImage__container__0hc15`,
	"fullImage__scale": `currentReport_fullImage__scale__yryV3`
};
export default ___CSS_LOADER_EXPORT___;
